export default __webpack_public_path__ + "static/style1.2_Andrey-7d154deb360911e72759fcf6b2591330.wav";